import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToolbarService {

  constructor() {
  }


  removeToolbarNode(node) {
    const nodeId = node.data('id');


    const toolbar = document.querySelector('#toolbar-' + nodeId);
    if (toolbar) {
      toolbar.remove();
    }
  }



  hideToolbarNode(node) {
    const nodeId = node.data('id');
    const toolbar: any = document.querySelector('#toolbar-' + nodeId);
    if (toolbar) {
      toolbar.style.visibility = 'hidden';
    }
  }

  showToolbarNode(node) {
    const nodeId = node.data('id');
    const toolbar: any = document.querySelector('#toolbar-' + nodeId);
    if (toolbar) {
      toolbar.style.visibility = 'visible';
    }
  }
  // PARTIE COLLAPSE

  collapseNode(node, that, color) {
    node.data('collapsed', 'true');
    const connectedEdges = node.connectedEdges('edge[source="' + node.data('id') + '"][secondary="' + false + '"]');
    const listEdgeSecondaryTarget = that.cy.elements('edge[target="' + node.data('id') + '"][secondary="' + true + '"]');
    this.updateEdge(listEdgeSecondaryTarget, color, '');
    const listEdgeSecondarySource = that.cy.elements('edge[source="' + node.data('id') + '"][secondary="' + true + '"]');
    this.updateEdge(listEdgeSecondarySource, color, '');
    if (connectedEdges.length) {
      connectedEdges.map((edge) => {

        if (edge.style('visibility') === 'visible') {
          edge.style('visibility', 'hidden');
          edge.target().map((subnode) => {
            subnode.style('visibility', 'hidden');
            subnode.data('show', false);
            this.hideToolbarNode(subnode);
            this.collapseNode(subnode, that, that.colorBackground);
          });
        }
      });
    }
    that.emitChange('update');
  }

  expandNode(node, that) {

    const color = '#D3D3D3';
    const connectedEdges = node.connectedEdges(`[source="${node.data('id')}"]`);
    const listEdgeSecondaryTarget = that.cy.elements('edge[target="' + node.data('id') + '"][secondary="' + '' + '"]');
    this.updateEdge(listEdgeSecondaryTarget, color, 'true');
    const listEdgeSecondarySource = that.cy.elements('edge[source="' + node.data('id') + '"][secondary="' + '' + '"]');
    this.updateEdge(listEdgeSecondarySource, color, 'true');
    node.data('collapsed', 'false');

    if (connectedEdges.length) {
      connectedEdges.map((edge) => {

        if (edge.style('visibility') === 'hidden') {
          edge.style('visibility', 'visible');
          edge.target().map((subnode) => {
            subnode.style('visibility', 'visible');
            subnode.data('show', true);
            this.showToolbarNode(subnode);
            this.expandNode(subnode, that);
          });
        }

      });
    }
    this.hideToolbarNode(node);
    that.emitChange('update');
  }
  updateEdge(listEdege: any, color: string, status: string ) {
    if (listEdege.length > 0) {
      delete listEdege['_private'];
      delete listEdege['length'];
      listEdege = Object.values(listEdege);
      let edge: any;
      for (edge in listEdege) {
        edge = listEdege[edge];
        edge.data('secondary', status);
        edge.style('line-color', color);
        edge.style('target-arrow-color', color);
      }
    }
  }
  // FIN PARTIE COLLAPSE
}
